import { Box } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import React from "react";

const LoadingIcon = () => {
  return (
    <Box
      component={CancelIcon}
      sx={{
        width: "30px",
        fontSize: "20px",
        mr: "10px",
        alignSelf: "flex-start",
        color: "red",
      }}
    />
  );
};
export default LoadingIcon;
